var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_10779)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1.6665 9.33333C1.6665 8.39991 1.6665 7.9332 1.84816 7.57668C2.00795 7.26308 2.26292 7.00811 2.57652 6.84832C2.93304 6.66667 3.39975 6.66667 4.33317 6.66667H10.6665C11.5999 6.66667 12.0666 6.66667 12.4232 6.84832C12.7368 7.00811 12.9917 7.26308 13.1515 7.57668C13.3332 7.9332 13.3332 8.39991 13.3332 9.33333V15.6667C13.3332 16.6001 13.3332 17.0668 13.1515 17.4233C12.9917 17.7369 12.7368 17.9919 12.4232 18.1517C12.0666 18.3333 11.5999 18.3333 10.6665 18.3333H4.33317C3.39975 18.3333 2.93304 18.3333 2.57652 18.1517C2.26292 17.9919 2.00795 17.7369 1.84816 17.4233C1.6665 17.0668 1.6665 16.6001 1.6665 15.6667V9.33333Z",
    fill: "#531CB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 6.66667V4.33333C6.6665 3.39991 6.6665 2.9332 6.84816 2.57668C7.00795 2.26308 7.26292 2.00811 7.57652 1.84832C7.93304 1.66667 8.39975 1.66667 9.33317 1.66667H15.6665C16.5999 1.66667 17.0666 1.66667 17.4232 1.84832C17.7368 2.00811 17.9917 2.26308 18.1515 2.57668C18.3332 2.9332 18.3332 3.39991 18.3332 4.33333V10.6667C18.3332 11.6001 18.3332 12.0668 18.1515 12.4233C17.9917 12.7369 17.7368 12.9919 17.4232 13.1517C17.0666 13.3333 16.5999 13.3333 15.6665 13.3333H13.3332M4.33317 18.3333H10.6665C11.5999 18.3333 12.0666 18.3333 12.4232 18.1517C12.7368 17.9919 12.9917 17.7369 13.1515 17.4233C13.3332 17.0668 13.3332 16.6001 13.3332 15.6667V9.33333C13.3332 8.39991 13.3332 7.9332 13.1515 7.57668C12.9917 7.26308 12.7368 7.00811 12.4232 6.84832C12.0666 6.66667 11.5999 6.66667 10.6665 6.66667H4.33317C3.39975 6.66667 2.93304 6.66667 2.57652 6.84832C2.26292 7.00811 2.00795 7.26308 1.84816 7.57668C1.6665 7.9332 1.6665 8.39991 1.6665 9.33333V15.6667C1.6665 16.6001 1.6665 17.0668 1.84816 17.4233C2.00795 17.7369 2.26292 17.9919 2.57652 18.1517C2.93304 18.3333 3.39975 18.3333 4.33317 18.3333Z",
    stroke: "#531CB3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_10779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/Copy2.ce4ec537899f2b37567dc9feba04edee.svg";
export { ForwardRef as ReactComponent };